export default __webpack_public_path__ + "static/media/hawaii.a5905a41.png";